function IEWarning() {
  const warning = document.querySelector('[data-module="ie-warning"]');
  if(!warning) return;

  const cookieName = warning.dataset.cookieName;
  const button = warning.querySelector('[data-js-bind="close"]');

  button.addEventListener('click', function(){
    const weekFromNow = new Date(Date.now() + (1000 * 60 * 60 * 24 * 7)).toUTCString();
    document.cookie = cookieName + '=true; expires=' + weekFromNow;
    warning.hidden = true;
  });
}

IEWarning();
